import React from "react";
import { DataCard, CardContainer } from "components/styled/dataCard/DataCard";
import DataCardRow from "components/styled/dataCard/DataCardRow";
import FirmaDigitalIcon from "assets/icons/ic_signature.svg";
import getPhoneFormat from "libs/getPhoneFormat";
import { FirmaSolicitud } from "api/types/originacion/services/analisisSolicitudTypes";

const FirmaDigitalCard: React.FC<{
  telefono?: FirmaSolicitud["telefono"];
  isLoading?: boolean;
}> = ({ telefono, isLoading = false }) => {
  const renderTelefonos = () => {
    if (!telefono) return "-";
    return getPhoneFormat(telefono as any);
  };

  return (
    <CardContainer>
      <DataCard
        title="FIRMA DIGITAL"
        icon={<img src={FirmaDigitalIcon} alt="contact-icon" />}
      >
        <DataCardRow
          label="Celular"
          isLoading={isLoading}
          value={renderTelefonos()}
          selectable
        />
      </DataCard>
    </CardContainer>
  );
};

export default FirmaDigitalCard;
